import { useQuery } from '@tanstack/react-query';
import type { Forecast } from '@seo/types';
import { apiGet } from '@/lib/api';

const TERMINAL = new Set(['completed', 'failed', 'cancelled']);

export function useForecast(id: string) {
  return useQuery({
    queryKey: ['forecast', id],
    queryFn: () => apiGet<Forecast>(`/v1/forecasts/${id}`),
    enabled: Boolean(id),
    refetchInterval: (q) => {
      const data = q.state.data as Forecast | undefined;
      if (!data) return 4000;
      return TERMINAL.has(data.status) ? false : 4000;
    },
  });
}
